<p-card>

    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
            <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu> -->
            <!-- <app-sdlcmenu></app-sdlcmenu> -->
            <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
                (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
            </button>
        </div>
    </div>

</p-card>
<div class="grid mt-4">


    <p style="font-size:large; font-weight:bolder; color: red; margin-left:1rem;">
        Note : An Excel file will be generated that will contain the Organisation Statistics Data. Please check your
        Download folder after the program completes execution.
    </p>


    <!-- Generate Button -->
    <div class="col-12 md:col-4 sm:col-6 flex align-items-end">
        <p-button label="Generate" styleClass="reset-btn" pTooltip="Generate" (click)="downloadgridexcel()"
            tooltipPosition="right"></p-button>
    </div>

</div>